// extracted by mini-css-extract-plugin
export default {"mapViewWindow":"map_view_mapViewWindow__N9GEm","deviceBox":"map_view_deviceBox__b+QRN","variableBox":"map_view_variableBox__poVxu","descriptionBox":"map_view_descriptionBox__ci+e7"};